import { FormattedMessage as FM } from "react-intl";
import { cn } from "tools/ui";
import { ArrowLeftIcon } from "components/Icons";

function TableTitle({ layout, kind, showBackButton, handleReturn }) {
  if (layout?.hiddenTitle) return null;

  let style = "text-2xl md:text-4xl";

  if (kind === "small") {
    style = "text-base md:text-2xl";
  }

  const title = layout?.model && <FM id={layout.model} />;

  return (
    <div className="flex mr-10 md:my-auto text-neutral-500 items-center">
      {showBackButton && (
        <ArrowLeftIcon
          className="w-8 h-8 cursor-pointer mr-5"
          onClick={() => handleReturn?.()}
        />
      )}
      <span className={cn("truncate font-light", style)}>{title}</span>
    </div>
  );
}

export default TableTitle;
